import {
  AnalyticsSettings,
  ThreadExtendedActivitySettings,
  ThreadExtendedActivityType,
  User,
  YammerState,
} from '../../state/types';

type GetSelectedOnBehalfOfUserId = (state: YammerState) => User['id'] | undefined;
export const getSelectedOnBehalfOfUserId: GetSelectedOnBehalfOfUserId = (state) =>
  state.analyticsSettings.selectedOnBehalfOfUserId;

type GetSelectedNetworkActivitySettings = (state: YammerState) => AnalyticsSettings['networkActivitySettings'];
export const getSelectedNetworkActivitySettings: GetSelectedNetworkActivitySettings = (state) =>
  state.analyticsSettings.networkActivitySettings;

type GetAnalyticsSettings = (state: YammerState) => AnalyticsSettings;
export const getAnalyticsSettings: GetAnalyticsSettings = (state) => state.analyticsSettings;

type getThreadExtendedActivitySettings = (
  state: YammerState,
  activityType: ThreadExtendedActivityType
) => ThreadExtendedActivitySettings;
export const getThreadExtendedActivitySettings: getThreadExtendedActivitySettings = (state, activityType) => {
  switch (activityType) {
    case ThreadExtendedActivityType.StorylineAnnouncement:
      return state.analyticsSettings.threadExtendedActivitySettingsForStorylineAnnouncement;
    case ThreadExtendedActivityType.CommunityAnnouncement:
      return state.analyticsSettings.threadExtendedActivitySettingsForCommunityAnnouncement;
    default:
      return state.analyticsSettings.threadExtendedActivitySettingsForOthers;
  }
};
